// Import :focus-visible JS polyfill
import 'focus-visible'
import { createGlobalStyle, css } from 'styled-components'
import { normalize } from 'styled-normalize'

const GlobalStyles = createGlobalStyle<{ smoothScroll?: boolean }>`
  ${normalize}

  html {
    box-sizing: border-box;
    font-size: 100%;
    ${({ smoothScroll }) =>
      smoothScroll &&
      css`
        scroll-behavior: smooth;
      `}
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  body {
    background: #ffffff;
    color: ${({ theme }) => theme.colors.text};
    font-size: 1rem;
    font-family: ${({ theme }) => theme.fonts.primary};
    letter-spacing: 0.03em;
    overscroll-behavior-y: none;
  }

  a {
    color: currentColor;
    text-decoration: none;
  }
  
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
  }

  p {
    margin: 1em 0;
  }

  fieldset {
    border: none;
    padding: 0;
  }

  :focus {
    outline: ${({ theme }) => theme.colors.focus} auto 5px;
  }

  /* Mimick default focus for Firefox */
  :-moz-focusring {
    outline: rgb(247, 247, 247) dotted 1px;
  }

  .js-focus-visible :focus:not([data-focus-visible-added]) {
    outline: none;
  }

`

export default GlobalStyles
